import React, { PureComponent, Fragment } from "react";

import { BarChart, Bar, Tooltip, ResponsiveContainer, XAxis } from "recharts";

import {
  Metric,
  selectFormat,
  Error,
  StandardTooltip
} from "./../../Utils/Utils.js";
import Heading from "../../Elements/Heading";

class ViewsYesterdayDreamworks extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <Fragment>
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.views.two_days_ago.networks}
              icons_size={"sm"}
            >
              Views 2 Days Ago
            </Heading>
            <Metric {...data.views.two_days_ago} size={"lg"} />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Last 7 Days
            </Heading>
            <Metric value={data.views.last7} size={"md"} />
          </div>
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Last 30 Days
            </Heading>
            <Metric value={data.views.last30} size={"md"} />
          </div>
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Year-To-Date
            </Heading>

            <Metric value={data.views.ytd} size={"md"} />
          </div>
        </div>

        <div className="col-12">
          <Heading size={6} className={"mb-1"}>
            Aggregate Views By Month
          </Heading>

          <ResponsiveContainer height={100} width="100%">
            <BarChart
              width={150}
              height={100}
              data={data.views_by_month}
              margin={{
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              }}
            >
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);
                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            {Object.keys(payload).map(key => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Month:
                                  </span>
                                  <span className="standard-tooltip__value-header">
                                    {payload[key].payload.fullName}
                                  </span>
                                </header>

                                <main className="standard-tooltip__main">
                                  <div
                                    className="standard-tooltip__item"
                                    key={key}
                                  >
                                    <span className="standard-tooltip__key">
                                      <span
                                        className="standard-tooltip__icon"
                                        style={{ background: "#FA6E57" }}
                                      ></span>
                                      {payload[key].payload.fullName}
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                  <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar dataKey="count" fillOpacity={1} fill="url(#colorUv)" />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{
                  strokeWidth: 0,
                  fill: "#25263F"
                }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Fragment>
    );
  }
}

export default ViewsYesterdayDreamworks;
